import { useState, useEffect } from "react";
import { isNumber } from "../../Utils/Common";
import MoneyTransfer from "./index";
import { Tabs } from "antd";
import PayoutHistory2 from "./history";
const { TabPane } = Tabs;

const IndexComponent = () => {
  // const history = useHistory();
  const tabPosition = "left";
  const [searchText, setSearchText] = useState(null);
  // const [searchButton, setSearchButton] = useState(true);
  const [defaultKey, setDefaultKey] = useState("1");
  useEffect(() => {
    // console.log("AppLocalData----", appLocalData)
    // if(appLocalData) {
    //     setAppData(JSON.parse(appLocalData))
    // }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeHandler = (value) => {
    setDefaultKey(value);
  };

  const handleSearch = (e) => {
    // console.log("searchText----",e.target.value)
    if (e.target.value.length === 10) {
      // setSearchButton(false);
    } else {
      // setSearchButton(true);
    }
    setSearchText(e.target.value);
  };

  return (
    <div>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="card rounded-0 p-3">
              <Tabs
                defaultActiveKey={defaultKey}
                tabPosition={tabPosition}
                onTabScroll={"right"}
                onChange={(key) => onChangeHandler(key)}
              >
                <TabPane tab={`Home`} key="1">
                  <div className="h-100">
                    <div className="">
                      <div className="">
                        <div className="row mb-3">
                          <div className="input-group">
                            <div className="col-md-2"></div>
                            <div className="col-md-4">
                              <input
                                className="form-control py-2 border"
                                type="search"
                                defaultValue={searchText}
                                value={searchText}
                                onKeyDown={isNumber}
                                placeholder="Search ..."
                                maxLength={10}
                                onChange={(e) => handleSearch(e)}
                              />
                            </div>
                            {/* <button onClick={() => setSearchText(null)} className="btn btn-default ml-3 border" disabled={searchButton} type="button">
                                                                    <i className="fa fa-search" />
                                                                    Clear
                                                                </button> */}
                          </div>
                        </div>
                      </div>
                      {searchText && searchText.length === 10 && (
                        <MoneyTransfer mobile={searchText} />
                      )}
                    </div>
                  </div>
                </TabPane>
                <TabPane tab={`History`} key="4">
                  <div className="h-100">
                    <PayoutHistory2 />
                  </div>
                </TabPane>
                {/* <TabPane tab={`Refund`} key="5">
                                            <div className='h-100'>
                                                <RefundHistory />
                                            </div>
                                        </TabPane> */}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexComponent;
